/**
 * Valumize Algorithmic DMV API
 * Batch-run the algorithmic discount-multiple valuation across many holdings of a fund within the context of a specific Bottom-Up fund valuation. Mirrors the single-asset \"fox button\" calculation but scales it across a fund. Generated results are staged for user review and only written back to AssetValuation when the user explicitly accepts each one. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Agent review depth for the run. OFF = no agent. QUICK = fast internal-consistency read (no tools, no web search, max ~5 bullets). DEEP = full methodology with read tools + market research.
 */
export type AlgorithmicDmvAgentMode = 'OFF' | 'QUICK' | 'DEEP';

export const AlgorithmicDmvAgentMode = {
    Off: 'OFF' as AlgorithmicDmvAgentMode,
    Quick: 'QUICK' as AlgorithmicDmvAgentMode,
    Deep: 'DEEP' as AlgorithmicDmvAgentMode
};

